<template>
    <div :class="['field', {error: isInvalid(error, invalid)}]">
        <label>{{label}} <span v-show="labelInfo">- {{labelInfo}}</span></label>
        <button ref="btn" class="layout h center" :title="values" @click.prevent="onClick" @keydown.left="onArrowLeft" @keydown.up="onArrowUp" @keydown.down="onArrowDown" @keydown.right="onArrowRight" :tabindex="tab_index">
            <span v-if="content.length" class="values flex">
                {{ displayValue }}
            </span>
            <span v-else class="placeholder flex">
                {{ placeholder }}
            </span>
            <i class="fa fa-chevron-down"></i>
        </button>
        <div ref="dropdown" class="dropdown" v-show="isExpanded" @click="listClicked"><slot></slot></div>
        <div class="message">{{ error }}</div>
    </div>
</template>

<style lang="scss" scoped>
.field {
	height: 74px;
	color: #696B70;
	display: flex;
	flex-direction: column;
	padding-top: 20px;
	position: relative;
	width: 100%;
	
	&.inline {
		height: 24px;
		padding-top: 0;
		line-height: 16px;
		.input {
			height: 24px;
		}
		input {
			font-size: 13px;
		}
    }
    &.inverted {
        
        button.layout {
            .placeholder {
                color: #eee;
            }
            i {
                color: #eee;
            }
            &:hover {
                border-bottom-color: #fff;
                font-weight: 300;
                .placeholder {
                    color: #fff;
                }
                i {
                    color: #fff;
                }
            }
            &:focus {
                border-bottom-color: #fff;
            }
        }
    }
}
.field.error {
	label {
		color: #FE6B5B;
	}
	.message {
		color: #FE6B5B;
	}
	button.layout {
        border-bottom-color: #FE6B5B;
        i {
            color: #FE6B5B;
        }
	}
}
label {
	display: block;
	font-weight: 300;
	position: absolute;
	font-size: 11px;
	top: 2px;
	left: 0;
    transition: all .15s ease-out;
    span {
        color: #ABACAF;
        font-style: italic;
    }
}
.error {
	text-align: right;
	color: red;
	font-size: 13px;
	line-height: 20px;
}
button.layout  {
    // display: block;
    background: none;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #d2d2d2;
    height: 24px;
    line-height: 24px;
    padding: 0 0 4px 0;
    width: 100%;
    text-align: left;
    color: #333;
    &:hover {
        border-bottom-color: var(--color-brand);
        font-weight: 300;
    }
    &:focus {
        border-bottom-color: var(--color-brand);
        border-bottom-width: 2px;
    }
    &:active {
        top: 0;
        i {
            color: var(--color-brand);
        }
    }
    span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.placeholder {
    color: #d2d2d2;
}
i {
    color: #d2d2d2;
    margin: auto 3px;
}
.dropdown {
    position: absolute;
    top: 44px;
    z-index: 8000;
    background: #fff;
    box-shadow: 0 2px 21px -4px rgba(0,0,0,0.2);
    // padding: 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    max-height: 220px;
    overflow: auto;
    width: 100%;
    >*{
        padding: 6px 12px;
        text-align: left;
        
        &:hover {
            background: var(--color-brand-light);
        }
    }
}
</style>
<script>
    export default {
        name: "ListField",
        computed: {
            displayValue(){
                // console.log('dsp', this.options)
				if (!this.options) return
				const opt = this.options.find(o => o.getAttribute('data-value') === this.content)
				if (opt) return opt.innerHTML
				else return this.content
			}
        },
        watch: {
            values(){
                this.content = this.values
            }
        },
        props: {
            values: String,
            placeholder: String,
            label: String,
            labelInfo: String,
            error: String,
            invalid: Boolean,
            tab_index: {type: Number, default: null}
        },
        data(){
            return {
                isExpanded: false,
                content: this.values || '',
                options: []
            }
        },
        mounted(){
			this.boundHide = this.hide.bind(this)
            this.options = Array.from(this.$refs.dropdown.children)
            // console.log('opts', this.options)
			const opt = this.options.find(o => o.getAttribute('data-value') === this.$data.content)
			if (opt) opt.classList.add('selected')
		},
        methods: {
            hide(){
                this.isExpanded = false
            },
            focus(){
                this.$refs.btn.focus()
            },
            listClicked(e){
				// if (e.target.classList.contains('list-header')) return
                this.content = e.target.getAttribute('data-value') || e.target.innerText
                const selected = this.$refs.dropdown.querySelector('.selected')
				selected && selected.classList.remove('selected')
				e.target.classList.add('selected')
                // this.$emit('selected', e.target)
                console.log('this.content', this.content)
				this.$emit('input', this.content)
                this.isExpanded = false
			},
            onClick(event){
                event.stopPropagation()
                if (this.$refs.dropdown.children.length){
                    this.isExpanded = !this.isExpanded
                }
                console.log(this.$refs.dropdown.children.length)
                this.$emit("click", event, this);
            },
            isInvalid(err, invalid){
				return (err || invalid)
            },
            onArrowRight:function(e){
				this.$emit('focusleave', {
                    dir: 'right',
                    target: e.target
                })
                e.preventDefault()
				// console.log('keyup', e, e.target, e.target.selectionStart)
			},
			onArrowDown:function(e){
				this.$emit('focusleave', {
					dir: 'down',
					target: e.target
				})
				e.preventDefault()
				// console.log('keyup', e, e.target, e.target.selectionStart)
			},
			onArrowUp:function(e){
				this.$emit('focusleave', {
					dir: 'up',
					target: e.target
				})
				e.preventDefault()
				// console.log('keyup', e, e.target, e.target.selectionStart)
			},
			onArrowLeft: function(e){
				this.$emit('focusleave', {
                    dir: 'left',
                    target: e.target
                })
                e.preventDefault()
				console.log('keyup', e, e.target, e.target.selectionStart)
			},
        }
    }
</script>

